module.exports = ".panel-sign-list .unselect-sign,.panel-sign-list .show-sign{cursor:pointer;float:right}\n"